import { scroll } from '@seek/ca-myprofile-utils';
import { useTranslations } from '@vocab/react';
import {
  Alert,
  Box,
  Heading,
  Stack,
  Text,
  Button,
  Actions,
} from 'braid-design-system';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';

import { useAppConfig } from 'src/modules/appConfig';

import { ResumeItemList } from '../../Resume/EditResume/ManageResumes/ResumeItemList/ResumeItemList';
import { useResumes } from '../../Resume/data';
import { updateCreateStep } from '../actionCreators';
import { resumeLimit } from '../consts';
import { useGenerateResumeFromProfile } from '../data';
import { CreateStep } from '../reducer';

import translations from './.vocab';

export const ResumeLimit = () => {
  const { t } = useTranslations(translations);
  const dispatch = useDispatch();
  const { zone, language: languageCode } = useAppConfig();
  const { resumes } = useResumes();
  const [generateResumeFromProfile] = useGenerateResumeFromProfile();

  const resumeCount = resumes.length;
  const resumeLimitReached = resumeCount >= resumeLimit;

  const alertRef = useRef<HTMLDivElement>(null);

  const handleCreateResumeClick = () => {
    if (!resumeLimitReached) {
      dispatch(updateCreateStep(CreateStep.RESUME_CREATED));
      setTimeout(() => {
        generateResumeFromProfile({ zone, languageCode });
      }, 500);
    } else if (alertRef.current !== null) {
      scroll(alertRef.current);
    }
  };

  return (
    <Box ref={alertRef} background="surface" paddingX="gutter" paddingY="large">
      <Stack space="medium">
        <Heading level="3">{t('Manage resumés')}</Heading>
        {resumeLimitReached ? (
          <Alert tone="critical" data={{ automation: 'resume-limit-alert' }}>
            <Text>
              {t('You have reached your 10 resumé limit. Please ...')}
            </Text>
          </Alert>
        ) : (
          <Text>
            {t('Please click the Create a resumé button to continue.')}
          </Text>
        )}
        <ResumeItemList />
        <Actions>
          <Button
            tone="formAccent"
            onClick={handleCreateResumeClick}
            data={{ automation: 'resume-limit-create-resume' }}
          >
            {t('Create a resumé')}
          </Button>
        </Actions>
      </Stack>
    </Box>
  );
};
